import { TwoFAType } from '../../domain/two-factor';
import { TwoFactorMethodSetupCommonStep } from '../two-factor-method-setup-common/two-factor-method-setup-common.component';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { formatInputPhoneNumber, inputPhoneNumberRequiredValidator, inputPhoneNumberValidator } from '@ppl/components/input-phone-number';
import { I18nService } from '@ppl/i18n';
import { PPL_DIALOG_DATA, PplDialogRef } from '@ppl/ui/dialog';
import { TFormBuilder } from '@ppl/ui/form';
import { createDialogCloseResponse, createDialogSuccessResponse } from '@ppl/utils/dialog.utils';
import type {
  InputPhoneNumber
} from '@ppl/components/input-phone-number';
import type { TFormGroup } from '@ppl/ui/form';
import type { DialogResponse } from '@ppl/utils/dialog.utils';
import type { TwoFactorMethodSetupCommonFinishData, TwoFactorMethodSetupCommonInitData } from '../two-factor-method-setup-common/two-factor-method-setup-common.component';

@Component({
    selector: 'ppl-two-factor-method-setup-phone',
    templateUrl: './two-factor-method-setup-phone.component.html',
    styleUrls: ['./two-factor-method-setup-phone.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TwoFactorMethodSetupPhoneComponent {

  form: TFormGroup<TwoFactorMethodSetupPhoneFormData>;

  step = TwoFactorMethodSetupCommonStep.INIT;

  TwoFAType = TwoFAType;

  get securityToken() {
    return this.data.securityToken;
  }

  get actionDisabled() {
    return this.step === TwoFactorMethodSetupCommonStep.INIT
      ? !this.form.valid
      : false;
  }

  constructor(
    @Inject(PPL_DIALOG_DATA) private data: TwoFactorMethodSetupPhoneData,
    private dialogRef: PplDialogRef<
      TwoFactorMethodSetupPhoneComponent,
      DialogResponse<TwoFactorMethodSetupPhoneResponse>
    >,
    private fb: TFormBuilder,
    private i18nService: I18nService
  ) {
    this.form = this.fb.group<TwoFactorMethodSetupPhoneFormData>({
      phoneNumber: [null, [inputPhoneNumberRequiredValidator(), inputPhoneNumberValidator(this.i18nService)]]
    });

    this.getSetupData = this.getSetupData.bind(this);
  }

  getSetupData() {
    const { phoneNumber } = this.form.value;
    return {
      value: formatInputPhoneNumber(phoneNumber)
    };
  }

  onNextStep(data: TwoFactorMethodSetupCommonInitData) {
    this.step = TwoFactorMethodSetupCommonStep.VERIFY;
  }

  onCancel() {
    this.dialogRef.close(createDialogCloseResponse());
  }

  onFinish(data: TwoFactorMethodSetupCommonFinishData) {
    this.dialogRef.close(createDialogSuccessResponse(data));
  }
}

interface TwoFactorMethodSetupPhoneFormData {
  phoneNumber: InputPhoneNumber;
}

export interface TwoFactorMethodSetupPhoneData {
  securityToken: string;
}

export interface TwoFactorMethodSetupPhoneResponse {
  methodId: number;
}
